import { useCallback, useEffect, useState } from "react";
import { RankingsService } from "../../../../../core/http/services/RankingsService";
import { CategoriesService } from "../../../../../core/http/services/CategoriesService";

export default function useAdminRanking() {
  const [rankings, setRankings] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedRanking, setSelectedRanking] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [standings, setStandings] = useState([]);
  const [loadingRankings, setLoadingRankings] = useState(true);
  const [loadingStandings, setLoadingStandings] = useState(false);

  const fetchCategories = useCallback(async () => {
    const { status, data } = await CategoriesService.get();
    if (status !== 200) return;
    const list = data ?? [];
    setCategories(list);
    if (list.length > 0) setSelectedCategory(list[0].id);
  }, []);

  const fetchRankings = useCallback(async () => {
    setLoadingRankings(true);
    const { status, data } = await RankingsService.getAll();
    setLoadingRankings(false);
    if (status !== 200) return;
    const list = data ?? [];
    setRankings(list);
    if (list.length > 0) setSelectedRanking(list[0].id);
  }, []);

  useEffect(() => {
    fetchRankings();
    fetchCategories();
  }, [fetchRankings, fetchCategories]);

  const fetchStandings = useCallback(async (rankingId, categoryId) => {
    if (!rankingId || !categoryId) return;
    setLoadingStandings(true);
    const { status, data } = await RankingsService.getStandings(rankingId, categoryId);
    setLoadingStandings(false);
    if (status !== 200) {
      setStandings([]);
      return;
    }
    const raw = Array.isArray(data) ? data : (data?.standings ?? []);
    setStandings(
      raw.map((entry, index) => ({
        id: entry.playerId ?? entry.player?.id ?? entry.id ?? String(index),
        name: entry.playerName ?? entry.player?.name ?? entry.name ?? "—",
        points: entry.totalPoints ?? entry.points ?? 0,
        avatarUrl: entry.avatarUrl ?? entry.player?.avatarUrl ?? null,
        position: entry.position ?? index + 1,
        wins: entry.wins ?? 0,
        losses: entry.losses ?? 0,
        matchesPlayed: entry.matchesPlayed ?? 0,
        saldo: entry.saldo ?? 0,
      })),
    );
  }, []);

  useEffect(() => {
    fetchStandings(selectedRanking, selectedCategory);
  }, [selectedRanking, selectedCategory, fetchStandings]);

  return {
    rankings,
    categories,
    selectedRanking,
    selectedCategory,
    standings,
    loadingRankings,
    loadingStandings,
    setSelectedRanking,
    setSelectedCategory,
  };
}
